import { BaseService } from './core/BaseService';
import type { LoginResponse, SendCodeResponse, User } from '../types/auth';

class AuthService extends BaseService {
  async sendCode(phone: string): Promise<SendCodeResponse> {
    return this.post('/api/auth/send-code', { phone });
  }

  /** 查询手机号是否已注册（登录弹窗据此差异化显示邀请码栏） */
  async checkPhone(phone: string): Promise<{ registered: boolean }> {
    return this.post('/api/auth/check-phone', { phone });
  }

  async login(phone: string, code: string, inviteCode?: string): Promise<LoginResponse> {
    return this.post('/api/auth/login', { phone, code, invite_code: inviteCode });
  }

  async logout(): Promise<void> {
    return this.post('/api/auth/logout');
  }

  async getMe(): Promise<User> {
    return this.get('/api/auth/me');
  }

  /** 分池余额（points=订阅/永久池，dailyPoints=每日赠送池），总余额 = 两者之和 */
  async getPoints(): Promise<{ points: number; dailyPoints: number }> {
    return this.get('/api/user/points');
  }
}

export const authService = new AuthService();
